import {ReactNode} from "react";
import {string} from "yup";

import {validationMessages} from "../../../form/utils/validation_messages";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {LeadFormMessageSlot} from "./slots/LeadFormMessageSlot";
import {LeadFormBase} from "./LeadFormBase";

const extraSchema = {
    message: string().required(validationMessages.required).max(500, validationMessages.maxLength)
};

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    defaultMessage: string;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
}

export const LeadFormWithTopic = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, customHeader, defaultMessage, onSubmitDraft} = props;

    return (
        <LeadFormBase<{message: string}>
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                extraDefaultValues: {message: defaultMessage},
                extraSchema: extraSchema,
                customSourceSection: "context_trigger",
                onSubmitDraft,
                transformFormValues: (values) => ({
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                    marketing_email: values.marketing_email,
                    marketing_sms: values.marketing_sms,
                    message: values.message
                }),
                analyticsParams: {customSourceSection: "context_trigger"}
            }}
            customHeader={customHeader}
            buttonText="Wyślij"
        >
            {() => <LeadFormMessageSlot />}
        </LeadFormBase>
    );
};
import {ReactNode} from "react";
import {string} from "yup";

import {validationMessages} from "../../../form/utils/validation_messages";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {LeadFormMessageSlot} from "./slots/LeadFormMessageSlot";
import {LeadFormBase} from "./LeadFormBase";

const extraSchema = {
    message: string().required(validationMessages.required).max(500, validationMessages.maxLength)
};

interface IProps {
    handleModalClose: (forceClose?: boolean) => void;
    onSuccessfulSubmit: (
        sentApplication: IApplicationData | null,
        offer?: IOfferDetailApplication,
        property?: IPropertyDetailApplication,
        recommendedFilters?: Record<string, string>
    ) => Promise<void>;
    initialLeadFormValues: IApplicationFormValues | null;
    customHeader: ReactNode;
    defaultMessage: string;
    onSubmitDraft?: (values: IApplicationFormValues) => Promise<void>;
}

export const LeadFormWithTopic = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues, customHeader, defaultMessage, onSubmitDraft} = props;

    return (
        <LeadFormBase<{message: string}>
            config={{
                initialLeadFormValues,
                onSuccessfulSubmit,
                handleModalClose,
                extraDefaultValues: {message: defaultMessage},
                extraSchema: extraSchema,
                customSourceSection: "context_trigger",
                onSubmitDraft,
                transformFormValues: (values) => ({
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                    marketing_email: values.marketing_email,
                    marketing_sms: values.marketing_sms,
                    message: values.message
                }),
                analyticsParams: {customSourceSection: "context_trigger"}
            }}
            customHeader={customHeader}
            buttonText="Wyślij"
        >
            {() => <LeadFormMessageSlot />}
        </LeadFormBase>
    );
};
